export type AppEnv = 'local' | 'dev' | 'stg' | 'production'

const RAW_ENV = (import.meta.env.VITE_APP_ENV ?? 'local') as string
const KNOWN_ENVS: readonly AppEnv[] = ['local', 'dev', 'stg', 'production']

export const APP_ENV: AppEnv = (KNOWN_ENVS as readonly string[]).includes(RAW_ENV)
  ? (RAW_ENV as AppEnv)
  : 'local'

export const IS_PROD = APP_ENV === 'production'

const LOGO_BY_ENV: Record<AppEnv, string> = {
  production: '/vectorFP3Logo.svg',
  stg: '/vectorFP3Logo-stg.svg',
  dev: '/vectorFP3Logo-dev.svg',
  local: '/vectorFP3Logo-local.svg',
}

export const LOGO_SRC: string = LOGO_BY_ENV[APP_ENV]

// the installed-app icon directory for this tier. the manifest points at it at build time;
// the apple-touch-icon link in index.html is retargeted at runtime, since iOS reads that
// tag (not the manifest) when the user adds the app to their home screen.
export const APP_ICON_DIR = `/icons/${APP_ENV}`
